module.exports = __webpack_public_path__ + "img/2x.ad1c2f8.jpg";